import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton, TextFieldProps } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import t from '@/utils/translate';

export default (props: Omit<TextFieldProps, 'value'>) => {
  const [passwordVisibility, setVisibility] = useState(false);

  const localProps: Partial<TextFieldProps> = { ...props };

  if (typeof localProps.value !== 'undefined') {
    delete localProps.value;
  }

  return (
    <TextField
      {...localProps}
      type={passwordVisibility ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={passwordVisibility ? t('action.hidePwd') : t('action.showPwd')}
              onClick={() => setVisibility(!passwordVisibility)}
              edge="end"
            >
              {passwordVisibility ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};
